/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverdueInvoiceDebtDto
 */
export interface OverdueInvoiceDebtDto {
    /**
     * 
     * @type {string}
     * @memberof OverdueInvoiceDebtDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof OverdueInvoiceDebtDto
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof OverdueInvoiceDebtDto
     */
    totalOverdue: string;
    /**
     * 
     * @type {number}
     * @memberof OverdueInvoiceDebtDto
     */
    invoiceCount: number;
    /**
     * 
     * @type {Date}
     * @memberof OverdueInvoiceDebtDto
     */
    oldestDueDate?: Date | null;
}

/**
 * Check if a given object implements the OverdueInvoiceDebtDto interface.
 */
export function instanceOfOverdueInvoiceDebtDto(value: object): value is OverdueInvoiceDebtDto {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('totalOverdue' in value) || value['totalOverdue'] === undefined) return false;
    if (!('invoiceCount' in value) || value['invoiceCount'] === undefined) return false;
    return true;
}

export function OverdueInvoiceDebtDtoFromJSON(json: any): OverdueInvoiceDebtDto {
    return OverdueInvoiceDebtDtoFromJSONTyped(json, false);
}

export function OverdueInvoiceDebtDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverdueInvoiceDebtDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'totalOverdue': json['totalOverdue'],
        'invoiceCount': json['invoiceCount'],
        'oldestDueDate': json['oldestDueDate'] == null ? undefined : (new Date(json['oldestDueDate'])),
    };
}

export function OverdueInvoiceDebtDtoToJSON(value?: OverdueInvoiceDebtDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'totalOverdue': value['totalOverdue'],
        'invoiceCount': value['invoiceCount'],
        'oldestDueDate': value['oldestDueDate'] == null ? undefined : ((value['oldestDueDate'] as any).toISOString()),
    };
}

